import React, { useState, useEffect } from "react";
import "../ToggleButton/ToggleButton.css";
import ZustandValidationProponente from "../../Zustand/ZustandFormProponent";
import useStore from "../../Zustand/Zustand";

const ToggleButtonProponent = ({
  id,
  textOn = "Ligado",
  textOff = "Desligado",
  children,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const {setRendaMensalProponent4, setNomeCompletoProponente4, setNascimentoProponente4} = useStore()
  const { setButtonIsAtivoProponent, setProponentErro, setRendaProponente, setNomeProponente, setNascimentoProponente } =
    ZustandValidationProponente();

  const handleToggle = () => {
    setIsChecked(!isChecked);
    setRendaMensalProponent4("")
    setNomeCompletoProponente4("")
    setNascimentoProponente4("")
    setNomeProponente("")
    setRendaProponente("")
    setNascimentoProponente("")
  };



  useEffect(() => {
    setButtonIsAtivoProponent(isChecked);
    setProponentErro(isChecked);
  }, [isChecked, setButtonIsAtivoProponent]);

  return (
    <main>
      <div className="liga-desliga">
        <input
          type="checkbox"
          className="liga-desliga__checkbox"
          id={`liga-desliga-${id}`}
          checked={isChecked}
          onChange={handleToggle}
          style={{ fontFamily: "Inter" }}
        />
        <label
          htmlFor={`liga-desliga-${id}`}
          className="liga-desliga__botao"
        ></label>
        <span className="toggle-text">{isChecked ? textOn : textOff}</span>
      </div>

      {isChecked && <div className="mt-4 text-start">{children}</div>}
    </main>
  );
};

export default ToggleButtonProponent;
